module.exports = __webpack_public_path__ + "static/media/regal_mit_flasche.bd0f1b86.jpg";